import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type LengthFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const LengthField = (props: LengthFieldProps) => {
  const handleChange = (e: any) => {
    const { value } = e.target;
    if (value && Number(value)) {
      props.onChange(Math.abs(Number(value)));
    } else if (!value) {
      props.onChange(null);
    }
  };

  return (
    <EditorVisualTextField
      id="length"
      size="small"
      label="Length"
      name={props.name}
      inputProps={{ min: 1, inputMode: "numeric", pattern: "[0-9]*" }}
      onChange={handleChange}
      value={props.value}
      fullWidth
    />
  );
};

export default LengthField;
